module.exports = __webpack_public_path__ + "static/media/cross-edit.33ffeace.svg";